"use client";
import React from "react";
import gs, { colors } from "gstyles";
import Link from "components/common/Link";
import { Search } from "lucide-react";

const Header = () => {
  return (
    <div className="w-full h-[var(--header-height)]">
      <div className="fixed top-0 left-0 w-full h-[460px] bg-primary z-[-1]"></div>
      <header className="relative w-full flex items-center h-[var(--header-height)] bg-primary">
        <div className="container mx-auto px-6 flex items-center">
          <div className="sm:hidden">
            <Link href="/">
              {gs.icons({
                name: "logo-black",
                width: 100,

                color: colors.white,
              })}
            </Link>
          </div>
          <div className="hidden sm:block">
            <Link href="/">
              {gs.icons({
                name: "logo-black",
                width: 140,

                color: colors.white,
              })}
            </Link>
          </div>
          <div className="flex-1 flex justify-end">
            <form
              className="w-[200px] sm:w-[400px]"
              onSubmit={(e) => {
                e.preventDefault();
                const input = e.currentTarget.querySelector("input");
                if (input?.value) {
                  window.location.href = `/search?searchTerm=${input.value}`;
                }
              }}
            >
              <div className="relative">
                <input
                  type="text"
                  placeholder="Tìm kiếm..."
                  className="w-full px-4 py-2 rounded-full bg-white/20 text-white placeholder-white/70 focus:outline-none focus:bg-white/30"
                />
                <button
                  type="submit"
                  className="absolute right-3 top-1/2 -translate-y-1/2"
                >
                  <Search size={20} color={colors.white} />
                </button>
              </div>
            </form>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
